import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=1b9bc594&scoped=true"
import script from "./index1.vue?vue&type=script&lang=ts"
export * from "./index1.vue?vue&type=script&lang=ts"
import style0 from "./index1.vue?vue&type=style&index=0&id=1b9bc594&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9bc594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9bc594')) {
      api.createRecord('1b9bc594', component.options)
    } else {
      api.reload('1b9bc594', component.options)
    }
    module.hot.accept("./index1.vue?vue&type=template&id=1b9bc594&scoped=true", function () {
      api.rerender('1b9bc594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/index1.vue"
export default component.exports